var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.isButtonVisible),expression:"isButtonVisible"}],attrs:{"color":"accent","dark":"","fab":""},on:{"click":_vm.scrollToTop}},[_c('v-icon',[_vm._v("mdi-arrow-up")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }